module.exports = __webpack_public_path__ + "img/banner-loveShots.f9e5d503.png";